<template>
  <div class="animated fadeIn">
    <b-card>
      <template v-slot:header>
        <h5>Klaim Hadiah</h5>
      </template>

      <b-row class="mb-3">
        <b-col cols="12">
          <h6 class="font-600 mb-2">Klaim Hadiah</h6>
          <div class="hadiah-action-buttons d-flex flex-wrap align-items-center">
            <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" variant="pgiBtn">
              <i class="fa fa-search mr-2"></i>Pilih Anggota
            </b-button>
            <transition name="fade-slide">
              <b-button variant="pgiBtn" v-if="selectedRow" @click="onReset()">
                Reset
              </b-button>
            </transition>
          </div>
        </b-col>

        <transition name="fade-slide">
          <b-col cols='12' class="mt-3" v-if="selectedRow">
            <div class="form-content-wrapper mb-0">
              <h6 class="form-title mb-3">INFORMASI ANGGOTA</h6>
            </div>
            <div class="wrapper-detail-grid">
              <div class="detail-grid">
                <p class="mb-0 font-600">No Anggota</p>
                <p class="mb-0">{{ selectedRow.no || '-' }}</p>
              </div>
              <div class="detail-grid">
                <p class="mb-0 font-600">Jenis Identitas</p>
                <template v-if="selectedRow.identitas">
                  <ol class="ol-no-margin">
                    <li v-for="item in selectedRow.identitas" :key="item.id">
                      <strong>{{ item.jenisIdentitas }}</strong> - {{ item.noIdentitas }} <a
                        @click="openPreviewIdentitas(item.fotoIdentitas)"
                        style="cursor:pointer; font-weight:bold; color:#1e73be"> (Lihat Foto)</a>
                    </li>
                  </ol>
                </template>
              </div>
              <div class="detail-grid">
                <p class="mb-0 font-600">Nama</p>
                <p class="mb-0">{{ selectedRow.nama || '-' }}</p>
              </div>
              <div class="detail-grid">
                <p class="mb-0 font-600">No. HP</p>
                <p class="mb-0">{{ selectedRow.noHp || '-' }}</p>
              </div>
              <div class="detail-grid">
                <p class="mb-0 font-600">Alamat</p>
                <p class="mb-0">{{ selectedRow.alamat || '-' }}</p>
              </div>
            </div>
          </b-col>
        </transition>
        <transition name="fade-slide">

          <b-col cols="12" class="mt-3" v-if="selectedRow">
            <div class="form-content-wrapper mb-0">
              <h6 class="form-title mb-3">LIST HADIAH</h6>
            </div>
            <b-alert show variant="warning" v-if="stateGetHadiahClaim.error"
              class="d-flex justify-content-between align-items-center">
              <div>
                <strong>Gagal memuat data.</strong><br>
                Terjadi kesalahan saat mengambil klaim hadiah. Silakan coba lagi.
              </div>

              <b-button size="sm" variant="warning" @click="getHadiahClaim()">
                Coba lagi
              </b-button>
            </b-alert>
            <template v-else>
              <b-table bordered hover show-empty :busy="stateGetHadiahClaim.isLoading"
                :items="stateGetHadiahClaim.data" :no-local-sorting="false" :fields="fields" responsive class="mb-3">
                <template v-slot:table-busy>
                  <div div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading data...</strong>
                  </div>
                </template>
                <template v-slot:empty>
                  Tidak ada data.
                </template>
                <template v-slot:cell(status)="row">
                  <div v-if="row.item.status == STATUS_HADIAH.SUDAH_DIKLAIM" class="d-flex flex-column"
                    style="gap: 6px;">
                    <span class="status-box-md status-box-success" style="width: 111px; text-align: center;">
                      Sudah Diklaim
                    </span>
                    <ModalFoto isButton withLength :photos="getPathPhotos(row.item.evidencePhoto)" />
                    <span class="smallText">
                      Cabang: {{ row.item.cabang || '-' }}
                    </span>
                    <span class="smallText">
                      Petugas: {{ row.item.updatedBy || '-' }}
                    </span>
                    <span class="smallText">
                      Di klaim pada: {{ $helper.changeDateFormat(row.item.updatedAt) }} - {{
                        $helper.changeDateFormatGetHour(row.item.updatedAt) }}
                    </span>
                  </div>
                  <span class="status-box-md status-box-secondary" style="width: 111px; text-align: center;"
                    v-if="row.item.status == STATUS_HADIAH.BELUM_DIKLAIM">Belum
                    Diklaim</span>
                  <span class="status-box-md status-box-danger" style="width: 111px; text-align: center;"
                    v-if="row.item.status == STATUS_HADIAH.EXPIRED">Expired</span>
                </template>
                <template v-slot:cell(action)="row">
                  <b-button size="sm" variant="pgiBtn" @click="onShowModalKlaim(row.item.id)"
                    v-if="row.item.status == STATUS_HADIAH.BELUM_DIKLAIM">Klaim</b-button>
                </template>
              </b-table>
            </template>
          </b-col>
        </transition>

        <slot name="actions" />
        <slot name="extra-content" />
      </b-row>
    </b-card>

    <ModalPilihAnggota @anggota-selected="selectAnggota" />
    <ModalPreview modalId="modal-preview-identitas" :fotoPreview="activeFotoPreviewIdentitas" />
    <ModalPreview modalId="modal-preview-upload" :fotoPreview="activeFotoPreviewUpload" />
    <b-modal id="modal-klaim" title="Konfirmasi Klaim Hadiah" centered no-close-on-backdrop no-close-on-esc
      hide-header-close>
      <div>
        <p class="mb-0">Apakah Anda yakin untuk mengklaim hadiah ini? <br /> Jika ya, mohon unggah foto sebagai
          bukti klaim di bawah.</p>

        <div class="mt-3 form-content-wrapper mb-0">
          <FotoPendukungNonBaseFile class="mt-2" v-for="item in foto" v-bind:key="item.index" :fotoPendukung="item"
            :length="foto.length" :minLength="3" :lat="lat || 0" :long="long || 0" :isNotShowCam="true"
            :isNotRemove="true" @showModalPreview="openModalPreviewUpload" @onChange="onChangeFoto" />
        </div>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="isLoadingSubmitHadiah">Batal</b-button>
        <b-button variant="pgiBtn" @click="onClaimHadiah()" :disabled="isLoadingSubmitHadiah"> <b-spinner
            v-if="isLoadingSubmitHadiah" type="grow" small /> Kirim</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalPilihAnggota from '@/views/gadai/ModalPilihAnggota';
import ModalPreview from '@/components/webcam/ModalPreview';
import FotoPendukungNonBaseFile from '@/components/webcam/FotoPendukungNonBaseFile'
import ModalFoto from '@/components/modals/ModalFoto'

export default {
  components: {
    ModalPilihAnggota,
    ModalPreview,
    FotoPendukungNonBaseFile,
    ModalFoto,
  },
  data() {
    return {
      selectedRow: null,
      activeFotoPreviewIdentitas: '',
      fields: [
        { key: "voucherName", label: "Nama Hadiah" },
        { key: "status", label: "Status", thClass: 'max-w-150 min-w-150', tdClass: 'max-w-150 min-w-150' },
        { key: "action", label: "Aksi", thClass: 'text-center max-w-150', tdClass: 'text-center max-w-150' },
      ],
      foto: [],
      defaultLabels: ['Foto KTP', 'Foto Nasabah', 'Screenshot WA (Hadiah)'],
      fotoPendukungUrl: [],
      indexFotoPendukung: 0,
      fotoPendukungError: false,
      activeFotoPendukungIndex: null,
      activeFotoPreviewIndex: null,
      activeFotoPreviewUpload: '',
      lat: 0,
      long: 0,
      stateGetHadiahClaim: {
        data: [],
        isLoading: false,
        error: null,
      },
      idHadiah: null,
      isLoadingSubmitHadiah: false
    }
  },
  computed: {
    STATUS_HADIAH() {
      return CONSTANTS.VOUCHER.STATUS
    }
  },
  methods: {
    init() {
      for (let i = 0; i < 3; i++) {
        this.addFotoPendukung();
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          this.lat = position.coords.latitude
          this.long = position.coords.longitude
        },
        error => {
          console.log(error.message);
        },
      )
    },
    openSearchAnggotaModal() {
      this.$bvModal.show("modal-pilih-anggota")
    },
    selectAnggota(row) {
      this.selectedRow = row
      this.$bvModal.hide("modal-pilih-anggota")
      this.$emit('selection-change', true)
      this.getHadiahClaim()
    },
    getHadiahClaim() {
      const params = {
        noAnggota: this.selectedRow.no,
      }

      this.stateGetHadiahClaim.error = null;
      this.stateGetHadiahClaim.isLoading = true;
      this.$axios.get('voucher/get-voucher-claim', { params }).then(response => {
        this.stateGetHadiahClaim.data = response.data
        this.stateGetHadiahClaim.error = null
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateGetHadiahClaim.error = 'ERROR'
      }).finally(() => {
        this.stateGetHadiahClaim.isLoading = false;
      })
    },
    openPreviewIdentitas(foto) {
      this.activeFotoPreviewIdentitas = foto
      this.$bvModal.show("modal-preview-identitas")
    },
    openModalPreviewUpload(index) {
      this.activeFotoPreviewIndex = index
      let idx = this.foto.findIndex(item => item.index == this.activeFotoPreviewIndex);
      this.activeFotoPreviewUpload = this.foto[idx].activeFotoPendukungBase64
      this.$bvModal.show("modal-preview-upload")
    },
    onShowModalKlaim(id) {
      this.idHadiah = id
      this.$bvModal.show("modal-klaim")
    },
    addFotoPendukung() {
      this.foto.push({
        index: this.indexFotoPendukung,
        id: 0,
        label: this.defaultLabels[this.indexFotoPendukung] || 'Foto Pendukung',
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
      })
      this.indexFotoPendukung++;
    },
    createSafeFileCopy(file) {
      if (!(file instanceof File)) {
        return file;
      }

      return new File(
        [file],
        file.name,
        {
          type: file.type,
          lastModified: file.lastModified,
        }
      );
    },
    async onChangeFoto(file, index) {
      const fileUpload = this.createSafeFileCopy(file);
      const path = 'voucher/create-presigned-url-nasabah-voucher-claim';
      const params = { nasabahId: this.selectedRow.id };

      this.$store.dispatch("loading/show")
      const response = await this.$helper.uploadPresigned({ vue: this, path, params, fileUpload })
      this.$store.dispatch("loading/hide")

      if (!response.success) {
        const indexStateFoto = this.foto.findIndex(foto => foto.index === index);
        if (indexStateFoto === -1) return;

        const resetData = {
          index: index,
          id: 0,
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          urlFotoBarangPendukung: null,
        }

        this.$set(this.foto, indexStateFoto, resetData);
        this.$helper.toastErr(this, "Gagal upload foto. Silakan coba lagi.");
        return;
      }

      const baseUrl = this.$baseFilePathAws;
      let url = response.publicUrl;
      if (url.startsWith(baseUrl)) {
        url = url.slice(baseUrl.length);
      }
      this.$set(this.fotoPendukungUrl, index, url);
    },
    onClaimHadiah() {
      if (!this.validatePhotos()) return;

      const attachmentsFoto = this.fotoPendukungUrl.filter(Boolean)
      const payload = new URLSearchParams();
      const attachmentsValue = Array.isArray(attachmentsFoto)
        ? JSON.stringify(attachmentsFoto)
        : attachmentsFoto;

      payload.append('attachments', attachmentsValue);

      const params = {
        status: this.STATUS_HADIAH.SUDAH_DIKLAIM,
      };

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      this.isLoadingSubmitHadiah = true;
      this.$axios.put(`/voucher/${this.idHadiah}/update-status`, payload, {
        headers,
        params,
      }).then(response => {
        this.getHadiahClaim()
        this.$bvModal.hide("modal-klaim")
        this.$helper.toastSucc(this, response.data.name)
        this.foto = [];
        this.fotoPendukungUrl = [];
        this.indexFotoPendukung = 0;
        for (let i = 0; i < 3; i++) {
          this.addFotoPendukung();
        }
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingSubmitHadiah = false;
      })
    },
    onReset() {
      this.selectedRow = null;
      this.foto = [];
      this.fotoPendukungUrl = [];
      this.indexFotoPendukung = 0;
      for (let i = 0; i < 3; i++) {
        this.addFotoPendukung();
      }
      this.$emit('selection-change', false)
    },
    getPathPhotos(path) {
      let pathArray = [];
      if (Array.isArray(path)) {
        pathArray = path;
      } else if (typeof path === 'string') {
        try {
          const parsed = JSON.parse(path);
          pathArray = Array.isArray(parsed) ? parsed : [path];
        } catch (e) {
          pathArray = [path];
        }
      }

      const fullPaths = pathArray.map(item =>
        `${this.$baseFilePathAws}${item}`
      );
      return fullPaths;
    },
    validatePhotos() {
      const list = this.foto || [];
      const hasNull = list.some(item => item.fotoBarangPendukung == null);

      if (hasNull) {
        this.$helper.toastErr(this, "Harap unggah foto terlebih dahulu");
        return false;
      }

      const filledCount = list.filter(item => item.fotoBarangPendukung != null).length;
      if (filledCount < 3) {
        this.$helper.toastErr(this, "Foto minimal 3");
        return false;
      }

      return true;
    }
  },
  created() {
    this.init();
  },
}
</script>

<style scoped>
.wrapper-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.hadiah-action-buttons {
  gap: 8px;
}

.detail-grid {
  display: grid;
  grid-template-columns: 30% 70%;
  gap: 4px 16px;
}

.ol-no-margin {
  margin: 0;
  padding-inline: 15px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(16px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

@media (max-width: 576px) {
  .detail-grid {
    grid-template-columns: 100%;
  }
}
</style>
